document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initCarruseles();
  initGaleriaProducto();
  initVariantesProducto();
  initVistazoMovil();
  initDeslizarFotos();
  initTraducirFiltros();
});

// El filtro de precio viene de Shopify como "Price" (ingles). Lo pasamos a "Precio"
// en todo el area de filtros. Se vuelve a aplicar cuando los filtros se recargan.
function initTraducirFiltros() {
  var reemplazos = [
    [/\bPrice\b/g, 'Precio'],
    [/\bIn stock\b/g, 'Disponible'],
    [/\bOut of stock\b/g, 'Agotado'],
    [/\bAvailability\b/g, 'Disponibilidad']
  ];
  function traducirNodo(nodo) {
    var t = nodo.nodeValue, cambio = false;
    reemplazos.forEach(function (r) {
      if (r[0].test(t)) { t = t.replace(r[0], r[1]); cambio = true; }
    });
    if (cambio) nodo.nodeValue = t;
  }
  function run() {
    var zonas = document.querySelectorAll(
      'facet-filters-form, .facets, .facets-vertical, .mobile-facets, .active-facets, #FacetFiltersForm, #FacetFiltersFormMobile'
    );
    zonas.forEach(function (zona) {
      var w = document.createTreeWalker(zona, NodeFilter.SHOW_TEXT, null);
      var nodos = [];
      while (w.nextNode()) { nodos.push(w.currentNode); }
      nodos.forEach(traducirNodo);
    });
  }
  run();
  if ('MutationObserver' in window) {
    var base = document.getElementById('ProductGridContainer') || document.querySelector('main') || document.body;
    if (base) {
      var obs = new MutationObserver(function () { run(); });
      obs.observe(base, { childList: true, subtree: true });
    }
  }
}

// En el telefono se puede deslizar el dedo sobre la foto de una prenda para ver
// la segunda foto (la de la modelo) y volver. El "vistazo" automatico de arriba
// es la pista de que esto se puede hacer.
function initDeslizarFotos() {
  if (window.matchMedia('(hover: hover)').matches) return; // hay cursor: no hace falta
  var sel = '.ex-newin__card, .ex-tabs__card, .ex-recom__card, .ex-cc__card, .product-card-wrapper';
  var tarjetas = document.querySelectorAll(sel);
  if (!tarjetas.length) return;

  tarjetas.forEach(function (tarjeta) {
    var x0 = null, y0 = null, huboDeslizamiento = false;

    tarjeta.addEventListener('touchstart', function (e) {
      if (!e.touches || e.touches.length !== 1) return;
      x0 = e.touches[0].clientX;
      y0 = e.touches[0].clientY;
      huboDeslizamiento = false;
    }, { passive: true });

    tarjeta.addEventListener('touchmove', function (e) {
      if (x0 === null || !e.touches || e.touches.length !== 1) return;
      var dx = e.touches[0].clientX - x0;
      var dy = e.touches[0].clientY - y0;
      if (Math.abs(dx) > 30 && Math.abs(dx) > Math.abs(dy) * 1.5) huboDeslizamiento = true;
    }, { passive: true });

    tarjeta.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var t = (e.changedTouches && e.changedTouches[0]) ? e.changedTouches[0] : null;
      if (t) {
        var dx = t.clientX - x0;
        var dy = t.clientY - y0;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) {
          huboDeslizamiento = true;
          // izquierda = ver la modelo, derecha = volver a la prenda
          if (dx < 0) tarjeta.classList.add('ex-vistazo');
          else tarjeta.classList.remove('ex-vistazo');
        }
      }
      x0 = null; y0 = null;
    }, { passive: true });

    // si deslizo, que NO se abra el producto sin querer
    tarjeta.addEventListener('click', function (e) {
      if (huboDeslizamiento) {
        e.preventDefault();
        e.stopPropagation();
        huboDeslizamiento = false;
      }
    }, true);
  });
}

// En el telefono, las tarjetas ya NO cambian de foto al tocarlas.
// Historia del asunto: primero la segunda foto aparecia sola al ir bajando
// (molestaba), despues se cambio a "mientras el dedo este encima" (confundia:
// parecia que el toque cambiaba la foto en vez de abrir el producto).
// Decision de Jael (ago-2026): en el celular se muestra solo la portada y quien
// quiera ver mas entra al producto. Un toque = abrir el producto, sin sorpresas.
function initVistazoMovil() {
  // intencionalmente vacio
}

// En el editor de Shopify, al recargar una seccion, muestra su contenido enseguida.
document.addEventListener('shopify:section:load', function (e) {
  var raiz = e.target || document;
  raiz.querySelectorAll('.ex-reveal, .ex-reveal-stagger').forEach(function (el) {
    el.classList.add('ex-visible');
  });
});

function initReveal() {
  var els = document.querySelectorAll('.ex-reveal, .ex-reveal-stagger');
  if (!els.length) return;
  if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach(function (el) { el.classList.add('ex-visible'); });
    return;
  }
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('ex-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15 }
  );
  els.forEach(function (el) { observer.observe(el); });
}

function initCarruseles() {
  document.querySelectorAll('[data-ex-carrusel]').forEach(function (carrusel) {
    var track = carrusel.querySelector('[data-ex-track]');
    var prev = carrusel.querySelector('[data-ex-prev]');
    var next = carrusel.querySelector('[data-ex-next]');
    if (!track) return;

    function scrollByCard(dir) {
      var card = track.querySelector('[data-ex-card]');
      var gap = parseInt(getComputedStyle(track).columnGap || 24, 10);
      var amount = card ? card.getBoundingClientRect().width + gap : 300;
      track.scrollBy({ left: dir * amount, behavior: 'smooth' });
    }

    if (prev) prev.addEventListener('click', function () { scrollByCard(-1); });
    if (next) next.addEventListener('click', function () { scrollByCard(1); });
  });
}

function initGaleriaProducto() {
  document.querySelectorAll('[data-ex-galeria]').forEach(function (galeria) {
    var principal = galeria.querySelector('[data-ex-imagen-principal]');
    var minis = galeria.querySelectorAll('[data-ex-miniatura]');
    if (!principal || !minis.length) return;
    minis.forEach(function (mini) {
      mini.addEventListener('click', function () {
        var src = mini.getAttribute('data-full');
        if (!src) return;
        principal.removeAttribute('srcset');
        principal.removeAttribute('sizes');
        principal.src = src;
        minis.forEach(function (m) { m.classList.remove('ex-miniatura-activa'); });
        mini.classList.add('ex-miniatura-activa');
      });
    });
  });
}

function initVariantesProducto() {
  document.querySelectorAll('[data-ex-producto]').forEach(function (contenedor) {
    var dataEl = contenedor.querySelector('[data-ex-variantes-json]');
    if (!dataEl) return;
    var variantes;
    try {
      variantes = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }
    var selects = contenedor.querySelectorAll('[data-ex-opcion]');
    var idInput = contenedor.querySelector('[data-ex-variant-id]');
    var precioEl = contenedor.querySelector('[data-ex-precio]');
    var precioCompareEl = contenedor.querySelector('[data-ex-precio-compare]');
    var botonComprar = contenedor.querySelector('[data-ex-comprar]');
    var avisar = contenedor.querySelector('[data-ex-avisar]');
    var avisarBody = contenedor.querySelector('[data-ex-avisar-body]');
    var tituloProd = contenedor.getAttribute('data-ex-producto-titulo') || '';
    var tallaAgotada = contenedor.querySelector('[data-ex-talla-agotada]');
    var waNum = contenedor.getAttribute('data-ex-wa-num') || '';
    var esTambienTenemos = contenedor.getAttribute('data-ex-tt') === '1';
    var waEnlaces = contenedor.querySelectorAll('[data-ex-wa-ficha], [data-ex-wa-talla], [data-ex-wa-agotado]');
    if (!selects.length || !idInput) return;

    // Mensaje de WhatsApp con la prenda y lo que la clienta tiene elegido,
    // para que el chat no arranque preguntando "cual te interesa?".
    function refrescarWhatsApp(disponible) {
      if (!waNum || !waEnlaces.length) return;
      var partes = [];
      for (var i = 0; i < selects.length; i++) {
        var nom = (selects[i].getAttribute('data-ex-opcion-nombre') || '').toLowerCase();
        if (selects[i].value) partes.push(nom + ' ' + selects[i].value);
      }
      var detalle = partes.length ? ' en ' + partes.join(', ') : '';
      var texto;
      if (esTambienTenemos) {
        // Estas prendas nunca estuvieron a la venta en la web: no estan "agotadas".
        texto = 'Hola, me interesa ' + tituloProd + detalle + '. Vi que la tienen en tienda. ¿Me la pueden conseguir?';
      } else if (disponible) {
        texto = 'Hola, me interesa ' + tituloProd + detalle + '. ¿Me pueden ayudar?';
      } else {
        texto = 'Hola, vi ' + tituloProd + detalle + ' en la web y aparece agotado. ¿Lo tienen disponible?';
      }
      var url = 'https://wa.me/' + waNum + '?text=' + encodeURIComponent(texto);
      Array.prototype.forEach.call(waEnlaces, function (a) { a.setAttribute('href', url); });
    }

    function moneda(centavos) {
      return (centavos / 100).toLocaleString(document.documentElement.lang || 'es', {
        style: 'currency',
        currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD'
      });
    }

    function actualizar() {
      var valores = Array.prototype.map.call(selects, function (s) { return s.value; });
      var encontrada = variantes.find(function (v) {
        return v.options.every(function (op, i) { return op === valores[i]; });
      });
      if (!encontrada) return;
      idInput.value = encontrada.id;
      if (precioEl) precioEl.textContent = moneda(encontrada.price);
      if (precioCompareEl) {
        if (encontrada.compare_at_price && encontrada.compare_at_price > encontrada.price) {
          precioCompareEl.textContent = moneda(encontrada.compare_at_price);
          precioCompareEl.style.display = '';
        } else {
          precioCompareEl.style.display = 'none';
        }
      }
      if (botonComprar) {
        if (encontrada.available) {
          botonComprar.disabled = false;
          botonComprar.textContent = botonComprar.getAttribute('data-texto-disponible');
        } else {
          botonComprar.disabled = true;
          botonComprar.textContent = botonComprar.getAttribute('data-texto-agotado');
        }
      }
      if (avisar) {
        if (encontrada.available) {
          avisar.hidden = true;
        } else {
          avisar.hidden = false;
          if (avisarBody) {
            var desc = [];
            for (var k = 0; k < selects.length; k++) {
              var nom = selects[k].getAttribute('data-ex-opcion-nombre') || 'Opcion';
              desc.push(nom + ': ' + selects[k].value);
            }
            avisarBody.value = 'Aviso de reposicion solicitado para: ' + tituloProd + (desc.length ? ' (' + desc.join(', ') + ')' : '');
          }
        }
      }
      if (tallaAgotada) tallaAgotada.hidden = encontrada.available;
      refrescarWhatsApp(encontrada.available);
    }

    selects.forEach(function (s) { s.addEventListener('change', actualizar); });
    actualizar();
  });
}
